module.exports = __webpack_public_path__ + "img/Whiplash_Newman.46012037.jpeg";